import { NavLinkProps } from 'react-router';
import { NavigationLinkWrapper } from './styles';

type NavigationLinkType = NavLinkProps & {
  size?: 'medium' | 'large';
  width?: string;
};

export const NavigationLink = ({ children, size = 'medium', width, ...props }: NavigationLinkType) => {
  return (
    <NavigationLinkWrapper size={size} width={width} {...props}>
      {children}
    </NavigationLinkWrapper>
  );
};
